<h2 mat-dialog-title>
  <mat-icon>engineering</mat-icon>
  Developer notes · Issue #{{ data.issueNumber }}
</h2>

<mat-dialog-content>
  @if (loading) {
    <p class="muted">Loading…</p>
  } @else {
    <p class="hint">
      Internal working notes for the dev team — deployment steps, migration patches to run, anything
      that should not sit in the public comment thread. Only holders of the developer role can see this.
    </p>

    <mat-form-field appearance="fill" class="full">
      <mat-label>Notes</mat-label>
      <textarea matInput [(ngModel)]="notes" rows="8"
                placeholder="e.g. Run migration patch 0042 after deployment."></textarea>
    </mat-form-field>

    @if (lastEdit?.updatedByUserName) {
      <p class="last-edit">
        Last edited by {{ lastEdit!.updatedByUserName }}
        on {{ lastEdit!.updatedDate | date:"d MMMM y 'at' HH:mm" }}
      </p>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="loading || saving" (click)="save()">Save</button>
</mat-dialog-actions>
